// Module
var code = "<script id=\"wcc-components-comment-clear-abuse-report-button\" type=\"text/template\">\r\n    <span class=\"wcc-link\" data-bind=\"visible: !isBusy(), click: clearAbuseReport, text: labels.ClearReport\"></span>\r\n    <wcc-loader params=\"visible: isBusy, inline: true\"></wcc-loader>\r\n</script>";
// Exports
module.exports = code;